import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { FormSidebarComponent } from '@zaoblako/web/shared/components/form-sidebar/form-sidebar.component';
import { NewsletterWelcomeSystemComponent } from '@zaoblako/web/shared/components/newsletter-welcome-system/newsletter-welcome-system.component';
import { WelcomeSystemComponent } from '@zaoblako/web/shared/components/welcome-system/welcome-system.component';
import { CrmMenuComponent } from '@zaoblako/web/shared/layouts/crm-menu/crm-menu.component';
import { FrmInformerBottomBarComponent } from '@zaoblako/web/shared/layouts/frm-informer-bottom-bar/frm-informer-bottom-bar.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  selector: 'crm-layout',
  templateUrl: './common.layout.component.html',
  styleUrls: ['./common.layout.component.scss'],
  imports: [
    CommonModule,
    CrmMenuComponent,
    FrmInformerBottomBarComponent,
    RouterModule,
    FormSidebarComponent
  ],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonLayoutComponent implements OnInit, OnDestroy {
  public menuMinimized: boolean = localStorage.getItem('user.settings.menu-minimized') === 'true';
  public readonly devEnvironment = environment.production === false;
  private windowWidth: number;

  private ref: DynamicDialogRef;

  public constructor(
    private readonly dialogService: DialogService,
    public readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    this.windowWidth = window.innerWidth;
    if (!localStorage.getItem('user.settings.menu-minimized') && this.windowWidth < 992) {
      this.menuMinimized = true;
    }

    if (this.globalService.globalInfo.tenantInfo?.showDebitWelcome) {
      setTimeout(() => {
        this.loadNewsletterWelcomeSystemModal();
      }, 2000);
    } else if (this.globalService.globalInfo.tenantInfo?.showWelcome) {
      setTimeout(() => {
        this.loadWelcomeSystemModal();
      }, 7000);
    }

    this.globalService.showWelcome$.subscribe((showWelcome) => {
      if (showWelcome) {
        this.loadWelcomeSystemModal();
      }
    });
  }

  public ngOnDestroy(): void {
    this.ref?.destroy();
  }

  @HostListener('window:resize')
  private onWindowResize() {
    if (window.innerWidth < 992 && this.windowWidth >= 992 && !this.menuMinimized) {
      this.menuMinimized = true;
      this.saveMenuState();
    } else if (window.innerWidth >= 992 && this.windowWidth < 992 && this.menuMinimized) {
      this.menuMinimized = false;
      this.saveMenuState();
    }
    this.windowWidth = window.innerWidth;
  }

  public onMenuToggle(nextMinimized: boolean) {
    this.menuMinimized = nextMinimized;
    this.saveMenuState();
  }

  public saveMenuState() {
    localStorage.setItem('user.settings.menu-minimized', JSON.stringify(this.menuMinimized));
  }

  public loadWelcomeSystemModal() {
    this.ref = this.dialogService.open(WelcomeSystemComponent, {
      header: 'Добро пожаловать в ФРМ',
      contentStyle: { overflow: 'auto', padding: 0, 'border-radius': '1.5rem' },
      styleClass: 'xl:w-7 lg:w-9 md:w-11 w-full text-center border-round-3xl',
      style: { 'min-width': '400px', 'max-width': '1250px' },
      focusOnShow: false,
      closable: false,
      showHeader: false
    });
  }

  public loadNewsletterWelcomeSystemModal() {
    this.ref = this.dialogService.open(NewsletterWelcomeSystemComponent, {
      header: 'Добро пожаловать в ФРМ',
      contentStyle: { overflow: 'auto', padding: 0, 'border-radius': '1.5rem' },
      styleClass: 'xl:w-7 lg:w-9 md:w-11 w-full text-center border-round-3xl z-5',
      style: { 'min-width': '400px', 'max-width': '1250px' },
      focusOnShow: false,
      closable: false,
      showHeader: false
    });
  }
}
